import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { useCallback } from "react";

export const useDragAndDrop = (items, setItems, deleting) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { delay: 1, tolerance: 5 },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = useCallback(
    (event) => {
      const { active, over } = event;
      if (!over) return;
      if (active.id !== over.id && !deleting) {
        const oldIndex = items.findIndex(({ id }) => id === active.id);
        const newIndex = items.findIndex(({ id }) => id === over.id);
        if (oldIndex !== newIndex) {
          const sortedItems = arrayMove(items, oldIndex, newIndex);
          setItems(sortedItems);
        }
      }
    },
    [items, setItems, deleting]
  );

  return { sensors, handleDragEnd };
};
